import { useEffect } from "react";
import ReactMarkdown from "react-markdown";
import { useQuery } from "react-query";
import styled from "styled-components";
import { getOneDivisionItem, getOnePageItem } from "../api/api";
import { ImagesEntity, IInnerPage, IInnerDivision } from "../types/inner_page";
import Loader from "react-loader-spinner";
import { GLOBAL_MEDIA_QUERIES, primaryColors, secondaryColors } from "../constatnts";
import { useTranslation } from "react-i18next";
import {useMedia} from "react-media"
import { IMedia } from "../types/types";
import InnerPageLayout from "../Components/Layout/InnerPageLayout";
import { useParams } from "react-router-dom";
import Caac from "../Components/Chart/caac.js";



interface IProps {
  id?: string;
}
const DivisionsPage = (props: IProps) => {
  const matches = useMedia({ queries: GLOBAL_MEDIA_QUERIES });
  let { id } = useParams(); 

  const {  i18n } = useTranslation();

  const { isLoading, error, data, refetch }: any = useQuery(
    `innerDivisionData-${id}`,
    () => getOneDivisionItem({ id: id || "1", language: i18n.language })
  );

  useEffect(() => {
    refetch();
  }, [i18n.language]);

  if (isLoading)
    return (
      <InnerPageLayout>
        <LoaderContainer>
          <Loader
            type="Puff"
            color="#ffffff"
            height={70}
            width={70}
            timeout={3000} //3 secs
          />
        </LoaderContainer>
      </InnerPageLayout>
    );

  if (error)
    return (
      <InnerPageLayout>
        <div></div>
      </InnerPageLayout>
    );

  let pageItem: IInnerDivision = data["data"];
  return (
    <InnerPageLayout>
      <>
        <Container  {...matches}>
          <Content>
            <h4 className="shape-round mb-lg-5 pb-5">{pageItem.title}</h4>


            <ReactMarkdown>{pageItem.content}</ReactMarkdown> <Spacer />
          </Content>
          <ImagesContainer>
            {pageItem.images.map((image: ImagesEntity) => (
              <Image src={`${process.env.REACT_APP_CMS}${image?.url}`}  {...matches} />
            ))}
          </ImagesContainer>
        </Container>

        <br />

        <Container  {...matches}>
          <Content>
            <h4 className="shape-round mb-lg-5 pb-5">الهيكل الاداري</h4>

            <div dir="ltr">
              <Caac ds={pageItem.structure} />
            </div>
          </Content>
        </Container>



      </>
    </InnerPageLayout>
  );
};


const TitleImage = styled.img`
  position: absolute;
  width: 80px;
  top: 0;
  z-index: -1;
  right: -10px;
`;

const Container = styled.div<IMedia>`
  padding: ${(props) => (props.large ? "30px 70px" : "10px 10px")};
  flex-direction : ${(props) => (props.large ? "row" : "column-reverse")};
  display: flex;
  position: relative;
`;

const Content = styled.div`
  padding: 10px 30px;
  line-height: 1.5em;
  position: relative;
  flex:1;
  color: ${primaryColors[3]};
  margin:10px;
`;

const ImagesContainer = styled.div`


`;
const Title = styled.h1`
  color: ${primaryColors[0]};
`;
const SubTitle = styled.h4`
  color: ${secondaryColors[0]};
`;

const Spacer = styled.div`
  height: 30px;
  width: 30px;
`;

const Image = styled.img<IMedia>`
  width: ${(props) => (props.large ? "45vw" : "100vw")};
  box-shadow: 20px 19px 0 0 rgb(189 189 189 / 50%);
  object-fit: contain;
    height: 500px;
`;
const LoaderContainer = styled.div`
  min-height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export default DivisionsPage;
